import React, { useState, useEffect } from "react";
import { Form, FloatingLabel } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import inputStyles from '../ManagementPages.module.css';

const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

const SetPassword = ({credentials, handleCredentials, setCredentials, setPasswordsMatch, testPassword, validated}) => {

    const [password1, setPassword1] = useState('');
    const [password2, setPassword2] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        setPasswordsMatch(password1 === password2);
    }, [password1, password2, setPasswordsMatch]);

    const handlePassword = e => {
        if (e.target.id === "pass1"){
            setPassword1(e.target.value);
        } else {
            setPassword2(e.target.value);
        }
        if (testPassword(e.target.value)) {
            setCredentials(prevCredentials => ({
                ...prevCredentials,
                newPassword: e.target.value
            }));
        }
    };

    return (
        <div style={{display: "flex", flexDirection:"column", gap:"10px"}}>
            <Form.Group>
                <FloatingLabel label="Email">
                    <Form.Control
                        id="username"
                        type="email"
                        disabled={true}
                        defaultValue={credentials.username}
                        onChange={handleCredentials}
                        className={`${inputStyles.BorderedComponent}`}
                        style={{ width: "100%" }}
                        required
                    />
                </FloatingLabel>
            </Form.Group>

            <Form.Group>
                <FloatingLabel label="Temporary Password">
                    <Form.Control
                        id="password"
                        type="text"
                        disabled={true}
                        defaultValue={credentials.password}
                        onChange={handleCredentials}
                        className={`${inputStyles.BorderedComponent}`}
                        style={{ width: "100%" }}
                        required
                    />
                </FloatingLabel>
            </Form.Group>

            <Form.Group>
                <FloatingLabel label="New Password">
                    <Form.Control
                        id="pass1"
                        value={password1}
                        style={{ width: "100%" }}
                        placeholder="New Password"
                        className={`${inputStyles.BorderedComponent}`}
                        onChange={handlePassword}
                        type={showPassword ? "text" : "password"}
                        required
                        pattern="^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$"
                        isInvalid={validated && (!password1 || !PASSWORD_REGEX.test(password1))}
                    />
                    <div
                        className={inputStyles["styled-icon-container"]}
                        onClick={() => setShowPassword((prev) => !prev)}
                        style={{ cursor: 'pointer' }}
                    >
                        {showPassword ?
                            <FontAwesomeIcon icon="fa-regular fa-eye" className="eye-icon" size="lg" /> :
                            <FontAwesomeIcon icon="fa-regular fa-eye-slash" className="eye-icon" size="lg" />
                        }
                    </div>
                    <Form.Control.Feedback type="invalid" style={{maxWidth: "300px"}}>
                        Password must contain at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character (!@#$%^&*).
                    </Form.Control.Feedback>
                </FloatingLabel>
            </Form.Group>

            <Form.Group>
                <FloatingLabel label="Confirm New Password">
                    <Form.Control
                        id="pass2"
                        value={password2}
                        style={{ width: "100%" }}
                        placeholder="Confirm New Password"
                        className={`${inputStyles.BorderedComponent}`}
                        onChange={handlePassword}
                        type={showPassword ? "text" : "password"}
                        required
                        pattern="^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$"
                        isInvalid={validated && (password1 !== password2 || !password2 || !PASSWORD_REGEX.test(password1))}
                    />
                    <div
                        className={inputStyles["styled-icon-container"]}
                        onClick={() => setShowPassword((prev) => !prev)}
                        style={{ cursor: 'pointer' }}
                    >
                        {showPassword ?
                            <FontAwesomeIcon icon="fa-regular fa-eye" className="eye-icon" size="lg" /> :
                            <FontAwesomeIcon icon="fa-regular fa-eye-slash" className="eye-icon" size="lg" />
                        }
                    </div>
                    <Form.Control.Feedback type="invalid">
                        Passwords do not match.
                    </Form.Control.Feedback>
                </FloatingLabel>
            </Form.Group>
        </div>
    )
}

export default SetPassword;
